import React from 'react';
import generateHreflang from 'lib/utils/generateHreflang';
import PATHS from 'lib/navigation/paths';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { mapNamedLocaleToLocale } from 'lib/data/localesMap';
import { defaultNS } from 'next-i18next.config';
import { PotentialMarketsView } from 'views/information-module/PotentialMarketsView';
import isCrawlers from 'lib/utils/isCrawlers';
import { serverFetch } from 'lib/utils/serverFetch';
import { API } from 'lib/config/axios';
import { HydrationWrapper } from 'views/common/components';

const PotentialMarketsPage = (props) => {
  const { serverData } = props;

  return (
    <HydrationWrapper>
      <PotentialMarketsView serverData={serverData?.seo_values} />
    </HydrationWrapper>
  );
};

export async function getServerSideProps(ctx) {
  const { locale } = ctx;
  let serverError = null;
  let layoutData = null;
  let serverData = null;
  const ssrRender = isCrawlers(ctx.req.headers['user-agent']);
  if (ssrRender) {
    const [layoutRes, seoValuesRes] = await Promise.all([
      serverFetch(ctx, API.layout, ctx.query),
      serverFetch(ctx, API.seoValues),
    ]);
    if (layoutRes.success && layoutRes.data) {
      layoutData = layoutRes.data;
      if (seoValuesRes.success && seoValuesRes.data) {
        serverData = { seo_values: seoValuesRes.data };
      } else {
        serverError = {
          statusCode: seoValuesRes.error.response.status,
        };
      }
    } else {
      serverError = {
        statusCode: layoutRes.error.response.status,
      };
    }
  }
  const hreflangData = generateHreflang(
    PATHS.franchise.marketOpportunities().url,
    locale,
  );
  return {
    props: {
      ...(await serverSideTranslations(mapNamedLocaleToLocale[locale], [
        ...defaultNS,
        'fe_er_potential_markets_page',
        'fe_er_common_franchise_header',
      ])),
      hreflangData,
      serverData,
      layoutData,
      serverError,
      ssrRender,
    },
  };
}

export default PotentialMarketsPage;
